import { create } from 'zustand';
import { doGET } from '../../utils/HttpUtils';
import { showError } from '../toaster';
import { Review, ReviewFilters } from '../../types/reviews';

const BASE_URL = '/booking-feedback';

interface ReviewState {
  data: Review[];
  totalPages: number;
  total: number;
  currentPage: number;
  rows: number;
  filters: ReviewFilters;
  isLoading: boolean;
  fetchGrid: () => Promise<void>;
  setFilters: (filters: ReviewFilters) => void;
  onPageChange: (_event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void;
}

const store = create<ReviewState>((set, get) => ({
  data: [],
  totalPages: 1,
  total: 0,
  currentPage: 1,
  rows: 10,
  filters: {},
  isLoading: false,

  fetchGrid: async () => {
    const { currentPage, rows, filters, isLoading } = get();
    if (isLoading) return;
    set({ isLoading: true });
    try {
      const params = new URLSearchParams({ page: String(currentPage), limit: String(rows) });
      if (filters.search) params.set('search', filters.search);
      if (filters.source) params.set('source', filters.source);
      if (filters.rating) params.set('rating', String(filters.rating));

      const response = await doGET(`${BASE_URL}?${params.toString()}`);
      if (response.status >= 200 && response.status < 400) {
        set({
          data: Array.isArray(response.data?.data) ? response.data.data : [],
          total: response.data?.pagination?.total ?? 0,
          totalPages: response.data?.pagination?.totalPages ?? 1,
        });
      } else {
        showError(response.message || 'Failed to fetch reviews');
      }
    } catch (_error) {
      showError('Failed to fetch reviews');
    } finally {
      set({ isLoading: false });
    }
  },

  setFilters: (filters) => {
    set({ filters, currentPage: 1 });
    get().fetchGrid();
  },

  onPageChange: (_event, page) => {
    const nextPage = page + 1;
    if (nextPage <= get().totalPages) {
      set({ currentPage: nextPage });
      get().fetchGrid();
    }
  },
}));

export const useReviewStore = () => store((state) => state);
